import axios from "./axios";

export async function fetchHourRates(params = {}) {
  return axios
    .get(`/offer_calculation_hour_rates`, { params })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject({
        response: {
          status: error.response?.status,
          data: error.response?.data,
        },
        message: error.message,
      });
    });
}

export async function fetchHourRate(id) {
  return axios
    .get(`/offer_calculation_hour_rates/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject({
        response: {
          status: error.response?.status,
          data: error.response?.data,
        },
        message: error.message,
      });
    });
}

export async function createHourRate(payload) {
  return axios
    .post(`/offer_calculation_hour_rates`, { offer_calculation_hour_rate: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject({
        response: {
          status: error.response?.status,
          data: error.response?.data,
        },
        message: error.message,
      });
    });
}

export async function updateHourRate(id, payload) {
  return axios
    .put(`/offer_calculation_hour_rates/${id}`, { offer_calculation_hour_rate: payload })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject({
        response: {
          status: error.response?.status,
          data: error.response?.data,
        },
        message: error.message,
      });
    });
}

export async function deleteHourRate(id) {
  return axios
    .delete(`/offer_calculation_hour_rates/${id}`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return Promise.reject({
        response: {
          status: error.response?.status,
          data: error.response?.data,
        },
        message: error.message,
      });
    });
}

